import { Dialog, Flex, Text } from "@mantine/core";
import {
  CheckCircleIcon,
  WarningCircleIcon,
  WarningIcon,
} from "@phosphor-icons/react";
import { useState } from "react";

type ToastType = "error" | "success" | "warning";

export type Toast = {
  type: ToastType;
  message: string;
  time?: number;
};

export type TostController = {
  toast: Toast | null;
  closeToast: () => void;
  showToast: (toast: Toast) => void;
};

export function useToast(isSticky: boolean = false): TostController {
  const [toast, setToast] = useState<Toast | null>(null);

  function showToast(toast: Toast) {
    setToast(toast);
    if (!isSticky) {
      setTimeout(() => {
        setToast(null);
      }, toast.time ?? 3000);
    }
  }

  return {
    toast,
    showToast,
    closeToast: () => setToast(null),
  };
}

export const ToastHost: React.FC<{
  toast: Toast | null;
  onClose: () => void;
}> = ({ toast, onClose }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 10,
        left: 10,
        right: 10,
        zIndex: 1000,
        maxWidth: "100vw",
      }}
    >
      {toast?.type == "error" && (
        <Dialog
          onClose={onClose}
          withBorder
          bg={"#fa5252"}
          opened
          position={{ top: 10, left: 10, right: 10 }}
          size="100%"
          w="100%"
          maw="100%"
        >
          <Flex align={"center"} gap={"xs"} wrap="wrap">
            <WarningCircleIcon color="#f71e25" size={16} />
            <Text size="xs" style={{ wordBreak: "break-word", flex: 1 }}>
              {toast.message}
            </Text>
          </Flex>
        </Dialog>
      )}
      {toast?.type == "success" && (
        <Dialog
          onClose={onClose}
          bg={"#cdffc2"}
          withBorder
          opened
          position={{ top: 10, left: 10, right: 10 }}
          size="100%"
          w="100%"
          maw="100%"
        >
          <Flex align={"center"} gap={"xs"} wrap="wrap">
            <CheckCircleIcon color="#1e4d14" size={16} />
            <Text size="xs" style={{ wordBreak: "break-word", flex: 1 }}>
              {toast.message}
            </Text>
          </Flex>
        </Dialog>
      )}
      {toast?.type === "warning" && (
        <Dialog
          onClose={onClose}
          radius="md"
          withCloseButton
          variant="outline"
          opened
          position={{ top: 10, left: 10, right: 10 }}
          size="100%"
          w="100%"
          maw="100%"
        >
          <Flex align={"center"} gap={"xs"} wrap="wrap">
            <WarningIcon size={16} />
            <Text size="xs" style={{ wordBreak: "break-word", flex: 1 }}>
              {toast.message}
            </Text>
          </Flex>
        </Dialog>
      )}
    </div>
  );
};
